'use strict';

import api from '../../api';

export default {
  namespaced: true,
  state: {
    stats: null
  },
  mutations: {
    clearStats(state) {
      state.stats = null;
    },
    setStats(state, stats) {
      state.stats = stats;
    }
  },
  actions: {
    clearStats({commit}) {
      commit('clearStats');
    },
    loadStats({commit}, id) {
      api.PoolStats.show({params: {id}})
        .then(stats => commit('setStats', stats));
    }
  },
  getters: {
    stats(state) {
      return state.stats;
    }
  }
};
